import { Category } from './CategoryDetail';
import { DISCOUNT_TYPE, Product, RedirectResponse, Seo } from './Product';

export enum HomePageItemType {
  CATEGORY = 2,
  BANNERLIST_BANNER = 3,
  BANNER_BANNERLIST = 4,
  BANNERLIST_PRODUCT = 5,
  PRODUCT_BANNERLIST = 6,
  BANNERLIST_CATEGORYLIST = 7,
  CATEGORYLIST_BANNERLIST = 8,
  BANNER_UNDER_CONTENT = 10,
}

export interface HomePage {
  homepage: HomePageContent;
  redirectProps?: RedirectResponse;
}

export interface HomePageContent {
  items: HomePageItem[];
  seo?: Seo;
  badge?: BadgeInfo;
}

export interface HomePageItem {
  type: HomePageItemType;
  category?: Category;
  banners?: HomePageBanner[];
  banner?: HomePageBanner;
  categories?: HomePageCategory[];
  products?: Product[];
  product?: Product;
  title?: string;
  url?: string;
  description?: string;
  imageUrl?: string;
  categoriesTitle?: string;
  showCategoryTitle: number;
}

export interface HomePageBanner {
  id: number;
  title?: string;
  imageUrl?: string;
  mobileImageUrl?: string;
  alt?: string;
  url?: string;
  badgeEndTime?: string;
  overlayBackgroundColor?: string;
  generateCode?: number;
}

export interface HomePageCategory {
  id: number;
  title: string;
  iconUrl: string;
  slug: string;
  url: string;
}

export enum CAMPAIGN_VIEW {
  NONE = 2,
  CENTER = 3,
  BOTTOM_RIGHT = 4,
}
export interface BadgeInfo {
  title?: string;
  url?: string;
  startTime?: string;
  endTime?: string;
  discountType?: DISCOUNT_TYPE;
  discountAmount?: number;
  campaignViewType?: CAMPAIGN_VIEW;
  countdownBackgroundColor?: string;
  countdownNumberColor?: string;
  countdownTextColor?: string;
}
